<template>
  <div>
    <b-container>
      {{globalVariable}}
      <b-button @click="globalVariable = !globalVariable">Change</b-button>
        <b-row class="align-items-center justify-content-center">
            <b-col cols="auto">
                <h3>Client view:</h3>
            </b-col>

            <b-col cols="auto">
                <b-form >
                    <b-form-group>
                        <b-form-select @input="selectView()" v-model="clientView" :options="optionsClient"></b-form-select>
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-button variant="msstreamblue" @click="createNewClient()" ><i class="fas fa-check"></i> New Client</b-button>
        </b-row>

        <b-card no-body border-variant="msstream" class="marginal">
            <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
            <h5>{{clientView.clientname}}</h5>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <h3>Information</h3>
                </b-row>
                <b-row>
                    <b-form-textarea
                    id="textarea"
                    v-model="clientJs"
                    placeholder=""
                    rows="0"
                    max-rows="20"
                    ></b-form-textarea>
                </b-row>
                <b-row class="justify-content-center" style="margin-top:15px;">
                    <b-button variant="msstreamblue" @click="putMyClient()" ><i class="fas fa-check"></i> Update</b-button>
                </b-row>

                <b-row>
                    <h3 class="marginal">Manage Users</h3>
                </b-row>
                <b-table show-empty centered responsive striped bordered :items="users" :fields="managerTable">
                  <template v-slot:cell(username)="row">
                    <div style="word-break:break-word; max-width:500px; margin:10px 0px">{{ row.item.username }}</div>
                  </template>
                  <template v-slot:cell(newPassword)="row">
                      <b-input-group>
                      <b-form-input
                          v-model="row.item._newPassword"
                          type="text"
                      > 
                      </b-form-input>
                      <b-input-group-append>
                          <b-button @click="putPassword(row.item)">Update</b-button>
                      </b-input-group-append>
                      </b-input-group>
                  </template>

                  <template v-slot:cell(remove)="row">
                      <b-row class="justify-content-center">
                          <b-button variant="quanteec" @click="userSelected = row.item.username;showModal('confirmDelete')" v-if="row.item.username !== $auth.getMyUser().username">Delete user</b-button>
                      </b-row>
                  </template>
                </b-table>
                <b-row class="justify-content-around">
                  <b-button variant="msstreamblue" @click="$router.push('/newuser')">Create a new user</b-button>
                  <b-button variant="msstreamblue" @click="$router.push('/manageuser')">Manage users</b-button>
                </b-row>

                <div v-if="clientView.type === 'plugin'">
                  <b-row>
                      <h3 class="marginal">Update Volume:</h3>
                  </b-row>
                  <p v-if="!clientView.freeOver">* Free volume NOT over ({{(clientView.totalQuantity) ? 1000 - clientView.totalQuantity : 1000}} GB left) *</p>
                  <p v-if="clientView.freeOver">* Free volume over *</p>

                  <b-form @submit.prevent="postQuantity()">
                    <b-form-group
                            label="Quantity (in GB):"
                        >
                      <b-form-input type="number" v-model="quantity" ></b-form-input>
                    </b-form-group>
                    <b-row>
                      <b-col cols="auto">
                        <b-button variant="msstreamblue" type="submit">Submit</b-button>
                      </b-col>
                    </b-row>
                  </b-form>

                </div>
            

                <b-row>
                    <h3 class="marginal">Upload Document:</h3>
                </b-row>
                    <b-form @submit.prevent="postDocument()">
                        <b-form-group
                            label="Type:"
                        >
                            <b-form-select v-model="typeFile" :options="optionsType"></b-form-select>
                        </b-form-group>

                        <b-form-group
                            label="Year:"
                        >
                            <b-form-input type="text" v-model="yearFile" ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Month:"
                        >
                          <b-form-input type="text" v-model="monthFile" ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="Price:"
                        >
                          <b-form-input type="number" v-model="priceFile" ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="Data:"
                        >
                          <b-form-input type="number" v-model="dataFile" ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="Document:"
                        >
                        
                            <b-form-file v-model="file" :state="Boolean(file)" required placeholder="Choose a file..."></b-form-file>
                        </b-form-group>
                        <b-row class="justify-content-center">
                            <b-col md="auto">
                                <b-button variant="msstreamblue" type="submit"> Upload document</b-button>
                            </b-col>
                        </b-row>
                    </b-form>

<h4>DOCUMENTS</h4>
          <h4 class="marginal">Bills:</h4>
          <div v-for="(yearsBills, indexBills) in billYears" v-bind:key="indexBills">
            <b-row>
              <b-col cols="12">
                <h5 @click="focusBill(yearsBills)" style="cursor: pointer">
                  <font-awesome-icon
                    v-if="focusYearBill !== yearsBills"
                    :icon="['fas', 'caret-right']"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-if="focusYearBill === yearsBills"
                    :icon="['fas', 'caret-down']"
                  ></font-awesome-icon>
                  {{ yearsBills }}
                </h5>
              </b-col>
            </b-row>
            <b-row v-if="focusYearBill === yearsBills">
              <b-col
                md="2"
                cols="4"
                v-for="bill in bills[yearsBills]"
                v-bind:key="bill.uuid"
              >
                <b-row class="justify-content-center">
                  <b-col lg="6" cols="12">
                    <b-img
                      :src="require('@/assets/pdf.png')"
                      style="cursor: pointer"
                      fluid
                      @click="downloadDocuments(bill.filename)"
                    ></b-img>
                  </b-col>
                </b-row>
                <b-row lg="6" class="justify-content-center">
                  <b-col cols="12" style="text-align: center">
                    <h6
                      style="cursor: pointer"
                      @click="downloadDocuments(bill.filename)"
                    >
                      {{ bill._month }}
                    </h6>
                    <!--<font-awesome-icon  style="cursor:pointer;" v-if="$auth.getMyUser().roles.indexOf('admin') > -1" :icon="['fas', 'trash-alt']" @click.prevent="deleteDocument(obj)"></font-awesome-icon>-->
                  </b-col>
                </b-row>
                <b-row class="justify-content-center">
                    <b-button class="mr-1" variant="msstreamblue" @click="sendMailBill(yearsBills, bill._month, bill.filename)">
                      <font-awesome-icon :icon="['fas', 'envelope']" ></font-awesome-icon>
                    </b-button>
                    <b-button class="mr-1" variant="quanteec" @click="billSelected=bill.filename;showModal('confirmBillDeletion')">
                      <font-awesome-icon :icon="['fas', 'trash']" ></font-awesome-icon>
                    </b-button>
                </b-row>
              </b-col>
            </b-row>
            <hr />
          </div>

          <br />
          <h4>Contract and annexes:</h4>

          <b-row>
            <b-col
              md="2"
              cols="4"
              v-for="contract in contracts"
              v-bind:key="contract.uuid"
            >
              <b-row class="justify-content-center">
                <b-col lg="6" cols="12">
                  <b-img
                    :src="require('@/assets/pdf.png')"
                    style="cursor: pointer"
                    fluid
                    @click="downloadDocuments(contract.filename)"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row lg="6" class="justify-content-center">
                <b-col cols="12" style="text-align: center">
                  <h6
                    style="cursor: pointer"
                    @click="downloadDocuments(contract.filename)"
                  >
                    {{ contract.filename }}
                  </h6>
                  <!--<font-awesome-icon  style="cursor:pointer;" v-if="$auth.getMyUser().roles.indexOf('admin') > -1" :icon="['fas', 'trash-alt']" @click.prevent="deleteDocument(obj)"></font-awesome-icon>-->
                </b-col>
              </b-row>
            </b-col>
          </b-row>
           <br />
          <h4>RIB:</h4>
          <b-row>
            <b-col
              md="2"
              cols="4"
              v-for="rib in ribs"
              v-bind:key="rib.uuid"
            >
              <b-row class="justify-content-center">
                <b-col lg="6" cols="12">
                  <b-img
                    :src="require('@/assets/pdf.png')"
                    style="cursor: pointer"
                    fluid
                    @click="downloadDocuments(rib.filename)"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row lg="6" class="justify-content-center">
                <b-col cols="12" style="text-align: center">
                  <h6
                    style="cursor: pointer"
                    @click="downloadDocuments(rib.filename)"
                  >
                    {{ rib.filename }}
                  </h6>
                  <!--<font-awesome-icon  style="cursor:pointer;" v-if="$auth.getMyUser().roles.indexOf('admin') > -1" :icon="['fas', 'trash-alt']" @click.prevent="deleteDocument(obj)"></font-awesome-icon>-->
                </b-col>
              </b-row>
            </b-col>
          </b-row>


                <b-row class="justify-content-center marginal">
                    <b-button variant="quanteec" @click="showModal('confirmDeleteClient')">Remove client</b-button>
                </b-row>
            </b-card-body>
        </b-card>
    </b-container>
    <b-modal ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Delete</h3>
      </div>
      <p>Are you sure you want to delete this user ?</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="removeUser(userSelected);hideModal('confirmDelete')">Yes, delete</b-btn>

          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('confirmDelete')">Cancel</b-btn>

      </b-row>
  </b-modal>
  <b-modal ref="confirmDeleteClient" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Delete</h3>
      </div>
      <p>Are you sure you want to delete this client ?</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="removeClient();hideModal('confirmDeleteClient')">Yes, delete</b-btn>
          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('confirmDeleteClient')">Cancel</b-btn>
      </b-row>
  </b-modal>
  <b-modal ref="UpdateOk" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Success</h3>
      </div>
      <p>Update success</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="msstreamblue" block @click="hideModal('UpdateOk')">Ok</b-btn>

      </b-row>
  </b-modal>
  <b-modal ref="UpdateError" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Update error. Please verify the syntax of the user</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('UpdateError')">Ok</b-btn>

      </b-row>
  </b-modal>
  <b-modal ref="UpdateParseError" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Can not parse the JSON object.</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('UpdateParseError')">Ok</b-btn>

      </b-row>
  </b-modal>

      <b-modal ref="confirmBillDeletion" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Delete</h3>
      </div>
      <p>Are you sure you want to delete this bill ?</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="deleteDocument(billSelected);hideModal('confirmBillDeletion')">Yes, delete</b-btn>

          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('confirmBillDeletion')">Cancel</b-btn>

      </b-row>
  </b-modal>
  </div>
</template>

<script>
import PriceAnalytics from "@/components/analytics/PriceAnalytics.vue";
import { saveAs } from 'file-saver';
import UserService from '@/services/user.service';
import ClientService from '@/services/client.service';
import DocumentService from '@/services/document.service';
import { EventBus } from '@/event-bus.js';
import PaymentService from '@/services/payment.service';
let paymentService = new PaymentService();
var userService = new UserService();
var clientService = new ClientService();
var documentService = new DocumentService();
export default {
  name: 'Admin',
  components: {
      PriceAnalytics
  },
  data: function() {
      return {
          currentView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
          loading: false,
          clientJs: "",
          clientView: {},
          typeFile: 'bills',
          yearFile: new Date().getFullYear() + '',
          monthFile: '',
          priceFile: 0,
          dataFile: 0,
          userFile: null,
          userSelected: null,
          users: [],
          clients: [],
          managerTable: [
                { key: "username", label: "User", sortable: true},
                { key: "newPassword", label: "Reset password"},
                { key: "remove", label: "Remove"}
          ],
          defaultForm: {
              defaultAudio: true,
              defaultMaxNumberOfQualities: 3,
              defaultEncoding: true,
              defaultEncodingLevel: 2,
              defaultEncodingSource: true
          },
          optionsType: [
              {value: "bills", text: "Bill"},
              {value: "contracts", text: "Contract"}
          ],
          optionsUser: [

          ],
          optionsClient: [

          ],
          optionsAudio: [
              { value: true, text: "True, the majority of my videos have audio" },
              { value: false, text: "False, none or only a few of my videos have audio" },
          ],
          optionsMaxNumberOfQualities: [
              { value: 2, text: "2" },
              { value: 3, text: "3 - Default value" },
              { value: 4, text: "4" },
              { value: 5, text: "5" },
              { value: 6, text: "6" },
          ],
          optionsEncoding: [
              { value: true, text: "Encoding, the majority of my videos should be encoded in multiple qualities" },
              { value: false, text: "Passthrough, none or only a few of my videos should be encoded in multiple qualities" },
          ],
          optionsEncodingLevel: [
              { value: 1, text: "Fast encoding / Low quality - good for a high number of live streams" },
              { value: 2, text: "Intermediate - Default value" },
              { value: 3, text: "Slow encoding / Good quality - good for high quality VoD" },
          ],
          optionsEncodingSource: [
              { value: true, text: "Use source video as the best quality - Improve the quality but reduce the efficiency of the player" },
              { value: false, text: "Encode all of the qualities - The best quality is defined by the encoding level but improve the efficiency of the player" },
          ],

          // handle scroll
          ScrollDown:false,
          ScrollUp:false,
          ScrollDown2:false,
          ScrollUp2:false,

          //Table with client information. Actually it is enter in the code. We need to ask information to the API
          clientMy:{},

          // Login and password. Need API real information
          newMail:"",
          checkPasswordValidity:"",
          modified:false,
          modifyPass:false,
          account:[{login:"",password:""}],
          newPassword: '',

          //document (need to put real one and to create a module to download them)
          ribs: {},
          bills: {},
          billYears: [],
          isFirstBill: true,
          contracts: {},
          contractYears: [],
          focusYearBill: "",
          focusYearContract: "",
          focusYearRIB: "",

          file: null,

          billSelected:null,
          quantity: 0
      }
  },
  mounted() {
    this.initTable()
    try {
        this.managescroll()
        this.managescroll2()
        this.getBills();
        this.getContracts();
        this.getRIBs();
    } catch(err) {}

    this.initMyUser();

  },
  computed:{
      getItems(){
          return this.items
      },
  },
  methods:{
      postQuantity() {
        paymentService.postPaymentQuantity(this.clientView.clientname, this.quantity, this.$auth.token())
        .then(() => {
          this.getAllClients()
          this.quantity = 0;
          this.$bvToast.toast(`Success updating the quantities of ${this.clientView.clientname}`, {
            title: `Success quantity`,
            variant: "success",
            solid: true
          })
        }).catch(err => {
          console.log(err);
          this.$bvToast.toast(`Error updating the quantities of ${this.clientView.clientname}`, {
            title: `Error quantity`,
            variant: "danger",
            solid: true
          })
        })

      },
      createNewClient() {
          this.$router.push('/newclient');
      },
      postDocument() {
          var formData = new FormData();
          formData.append('client', this.clientView.clientname);
          formData.append('type', this.typeFile);
          formData.append('year', this.yearFile);
          formData.append('month', this.monthFile.toLowerCase());
          formData.append('file', this.file, this.file.name);
          formData.append('price', this.priceFile);
          formData.append('data', this.dataFile);

          documentService.postDocument(this.$auth.token(), formData).then(() => {
              this.file = null;
              this.getBills();
              this.getContracts();
              this.getRIBs();
          })
      },
      sendMailBill(yearFile, monthFile, nameFile){
        documentService.sendMailBill(this.$auth.token(), this.clientView.clientname, yearFile, monthFile, nameFile)
        .then(()=>{
          this.$bvToast.toast(`Email has been successfully sent to ${this.clientView.clientname}`, {
            title: `Mail sent`,
            variant: "success",
            solid: true
          })
        }).catch((err)=>{
                    this.$bvToast.toast(`There has been an error sending mail to ${this.clientView.clientname}`, {
            title: `Error sending mail`,
            variant: "danger",
            solid: true
          })
        })
      },
      /*getBills() {
          if (this.$auth.getMyUser().roles.indexOf('manager') > -1) {
            var client = this.clientView.clientname;
            documentService.getDocuments(this.$auth.token(), {filter:JSON.stringify({type:"bills", client: client}), sort:{filename:-1}}).then((documents) => {
                this.bills = documents._embedded.map((x)=> x.filename);
            }).catch((err) => {
                console.log(err);
            })
          }
      },*/
      getBills() {
      if (this.$auth.getMyUser().roles.indexOf("manager") > -1) {
        let strUcFirst = function (a) {
          return (a + "").charAt(0).toUpperCase() + a.substr(1);
        };
        let months = [
          "december",
          "décembre",
          "november",
          "novembre",
          "october",
          "octobre",
          "september",
          "septembre",
          "august",
          "août",
          "july",
          "juillet",
          "june",
          "juin",
          "may",
          "mai",
          "april",
          "avril",
          "march",
          "mars",
          "february",
          "février",
          "january",
          "janvier",
        ];
        var client = this.clientView.clientname;
        documentService
          .getDocuments(this.$auth.token(), {
            filter: JSON.stringify({ type: "bills", client: client }),
            sort: { filename: -1 },
          })
          .then((documents) => {
            let billsPerYear = {};
            this.bills = [];
            for (let i = 0; i < documents._embedded.length; i++) {
              let bill = documents._embedded[i];
              bill._month = strUcFirst(bill.month);
              billsPerYear[bill.year] = billsPerYear[bill.year] || [];
              billsPerYear[bill.year].push(bill);
            }
            this.billYears = Object.keys(billsPerYear);
            this.billYears.sort((a, b) => +b - +a);
            for (let i = 0; i < this.billYears.length; i++) {
              billsPerYear[this.billYears[i]].sort((a, b) => {
                return (
                  months.indexOf(a.month.split(" ")[0]) -
                  months.indexOf(b.month.split(" ")[0])
                );
              });
            }
            if (this.billYears.length > 0 && this.isFirstBill) {
              this.focusYearBill = this.billYears[0];
            }
            this.isFirstBill = false;
            this.bills = billsPerYear;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    focusBill(yearsBills) {
      if (this.focusYearBill === yearsBills) {
        this.focusYearBill = "";
      } else {
        this.focusYearBill = yearsBills;
      }
    },
      getContracts() {
        if (this.$auth.getMyUser().roles.indexOf('manager') > -1) {
            var client = this.clientView.clientname;
            documentService.getDocuments(this.$auth.token(), {filter:JSON.stringify({type:"contracts", client: client})}).then((documents) => {
                this.contracts = documents._embedded;
            }).catch((err) => {
                console.log(err);
            })
        }
      },
      getRIBs() {
        if (this.$auth.getMyUser().roles.indexOf('manager') > -1) {
            var client = this.clientView.clientname;
            documentService.getDocuments(this.$auth.token(), {filter:JSON.stringify({type:"rib", client: client}),sort:JSON.stringify({filename: -1})}).then((documents) => {
                this.ribs = documents._embedded;
            }).catch((err) => {
                console.log(err);
            })
        }
      },
      downloadDocuments(filename) {
          documentService.downloadDocuments(this.$auth.token(), filename).then((data) => {
              saveAs(data, filename);
          }).catch((err) => {
              console.log(err);
          })
      },
      deleteDocument(filename) {
          documentService.deleteDocument(this.$auth.token(), filename).then((data) => {
              this.getBills();
              this.getContracts();
              this.getRibs();
          }).catch((err) => {
              console.log(err);
          })
      },
      initMyUser() {
          var user = this.$auth.getMyUser();
          var tableDefault = {...this.clientMy}
          var accountDefault = this.account.pop();
          this.account.push({...accountDefault, login: user.username});
          this.clientMy = {...tableDefault, ...user.client_infos[0]};
          this.getMyUser();
          this.getAllUsers();

        if (user.roles.indexOf('admin') > -1) {
              this.getAllClients();
          }
      },
      selectView() {
          this.$auth.setMyClientView(this.clientView.clientname);
          EventBus.$emit('ViewChanged', this.clientView.clientname);
          this.getBills();
          this.getContracts();
          this.getRIBs();
          this.getAllUsers();
          this.clientJs = JSON.stringify(this.clientView, null, 2)
      },
      getAllClients() {
        userService.getClients(this.$auth.token()).then((data) => {
              var clients = data;
              this.clients = clients;
              
              this.optionsClient = clients.map((elem) => {return {text: elem.clientname, value: elem}}).sort()
              this.optionsClient.forEach(x => {
                  if (x.text === this.currentView) {
                      this.clientView = x.value;
                  }
              })
          })
      },
      removeClient() {
          clientService.deleteClient(this.clientView.clientname, this.$auth.token()).then(() => {
              this.getAllClients();
          }).catch(err => {

          })
      },
      getAllUsers() {
          let params = (this.clientView.clientname) ? {client: this.clientView.clientname} : {client: "quanteec"};
          userService.getUsers(this.$auth.token(), params).then((data) => {
              var users = data;
              users.forEach(function(elem){
                  if (elem.roles.indexOf('manager') > -1) {
                      elem._isManager = true;
                  } else {
                      elem._isManager = false;
                  }
                  if (elem.roles.indexOf('editor') > -1) {
                      elem._isEditor = true;
                  } else {
                      elem._isEditor = false;
                  }
                  elem._newPassword = '';
              })
              this.users = users;
              this.optionsUser = users.map((elem) => elem.username).sort();
          })
      },
      getMyUser() {
          userService.getMyUser(this.$auth.token()).then((user) => {
              this.$auth.setMyUser(user);
              var accountDefault = this.account.pop();
              this.account.push({...accountDefault, login: user.username});
          }).catch((err) => {
              console.log(err);
          })
      },
      updateUserRole(user) {
          var userData = {
              roles: []
          };
          if (user._isManager) {
              userData.roles.push('manager');
          }
          if (user._isEditor) {
              userData.roles.push('editor');
          }
            userService.putUser(user.username, userData, this.$auth.token()).then((user) => {
              this.getAllUsers();
          }).catch((err) => {
              console.log(err);
          })
      },
      putMyClient() {
          let updatedClient = {};
          try {
            updatedClient = JSON.parse(this.clientJs);
          } catch(err) {
              this.showModal('UpdateParseError')
              return;
          }

          clientService.putClientAdmin(this.clientView.clientname, updatedClient, this.$auth.token()).then((client) => {
              let currentIndex = this.optionsClient.findIndex(x => x.value.clientname === client.clientname);
              this.optionsClient[currentIndex] = {text: client.clientname, value: client};

              this.clientView = client;

              this.optionsClient = this.optionsClient.splice(0);

              this.clientJs = JSON.stringify(client, null, 2); 
              this.showModal('UpdateOk')

          }).catch((err) => {
              console.log(err);
              this.showModal('UpdateError')
          })
      },
      putPassword(user) {
          userService.putUser(user.username, {password: user._newPassword}, this.$auth.token()).then((response) => {
              if (user.username === this.$auth.getMyUser().username) {
                this.$auth.setUsernamePassword(this.$auth.getMyUser().username, user._newPassword);
              }
              user._newPassword = "";
          }).catch((err) => {
              console.log(err);
          })
      },
      removeUser(username) {
          userService.deleteUserById(username, this.$auth.token()).then((client) => {
              this.getAllUsers();
          }).catch((err) => {
              console.log(err);
          })
      },
      initTable(){// Connect with API
          
          this.clientMy = {
                clientNumber: "",
                contractNumber:"",
                enterpriseName:"",
                SIRET:""  ,
                contactName:"",
                contactFirstName:"",
                email:"",
                phone:""
           }
          
          this.account = [
              {
                  username: "",
                  password: "default password"
              }
          ]
      },
      editPassword(){
          if(this.modifyPass==true){
              this.modifyPass=false
          }
          else{
              this.modifyPass=true
          }
      },

      managescroll2(){
        let div=document.querySelector('.onscroll2');
        if(div.scrollHeight-div.scrollTop!==div.clientHeight && div.scrollTop!==0){
            this.ScrollDown2=true
            this.ScrollUp2=true
        }
        else if(div.scrollHeight-div.scrollTop!==div.clientHeight && div.scrollTop===0){
            this.ScrollDown2=true
            this.ScrollUp2=false
        }
        else if(div.scrollHeight-div.scrollTop===div.clientHeight &&  div.scrollTop!==0){
            this.ScrollDown2=false
            this.ScrollUp2=true
        }
        else{
            this.ScrollDown2=false;
            this.ScrollUp2=false
        }
      },
      managescroll(){
        let div=document.querySelector('.onscroll');
        if(div.scrollHeight-div.scrollTop!==div.clientHeight && div.scrollTop!==0){
            this.ScrollDown=true
            this.ScrollUp=true
        }
        else if(div.scrollHeight-div.scrollTop!==div.clientHeight && div.scrollTop===0){
            this.ScrollDown=true
            this.ScrollUp=false
        }
        else if(div.scrollHeight-div.scrollTop===div.clientHeight &&  div.scrollTop!==0){
            this.ScrollDown=false
            this.ScrollUp=true
        }
        else{
            this.ScrollDown=false;
            this.ScrollUp=false
        }

      },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
      // Manage Arrow for moving the scroll bar
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      async goDown(){
          for(var i=0;i<40;i++){
            await this.sleep(5)
          document.querySelector('.onscroll').scrollTop=document.querySelector('.onscroll').scrollTop+1
          }
      },
      async goUp(){
          for(var i=0;i<40;i++){
            await this.sleep(5)
          document.querySelector('.onscroll').scrollTop=document.querySelector('.onscroll').scrollTop-1
          }
      },
      async goDown2(){
          for(var i=0;i<40;i++){
            await this.sleep(5)
          document.querySelector('.onscroll2').scrollTop=document.querySelector('.onscroll2').scrollTop+1
          }
      },
      async goUp2(){
          for(var i=0;i<40;i++){
            await this.sleep(5)
          document.querySelector('.onscroll2').scrollTop=document.querySelector('.onscroll2').scrollTop-1
          }
      }

  }
}
</script>
<style scoped lang="scss">
.pdfstyle{
    color: red;
    
}
.fa-download:hover{
    color:white
}
.item{
    border-bottom:#A9A9A9 2px solid;
    padding-top:1%
}
.item:hover{
    border-bottom:#A9A9A9 2px solid;
    padding-top:1%;
    background-color:#E6E6E6
}
.text{
    display:flex
}
.overflow{
    height:150px;
    overflow:auto;
    border:#A9A9A9 2px solid;
    border-radius:5px;
    
}
.overflow2{
    height:150px;
    overflow:auto;
    border:#A9A9A9 2px solid;
    border-top:none;
    
}
.overflow3{
    height:150px;
    overflow:auto;
    border:#A9A9A9 2px solid;
    border-bottom: none;
    
}
.overflow4{
    height:150px;
    overflow:auto;
    border:#A9A9A9 2px solid;
    border-top:none;
    border-bottom: none;
}
.bottom{
    border:#A9A9A9 2px solid;
    border-radius:5px;
    border-top:none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
}
.bottom:hover{
    border:#A9A9A9 2px solid;
    border-radius:5px;
    border-top:none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    background-color: #E6E6E6;
    cursor:pointer
}
.up{

    border:#A9A9A9 2px solid;
    border-radius:5px;
    border-bottom:none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
}
.up:hover{

    border:#A9A9A9 2px solid;
    border-radius:5px;
    border-bottom:none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    background-color: #E6E6E6;
    cursor:pointer
}


</style>